import { useEffect, useState } from 'react'
import { v4 as generateUuid } from 'uuid'

const persistId = (persistedIds, persistKey, persistValue) => {
  if (localStorage && persistKey){
    const updatedIds = {
      ...persistedIds,
      [persistKey]: persistValue,
    }

    localStorage.setItem('realhub:unique-ids', JSON.stringify(updatedIds))
  }
}

const useUniqueId = (options = {}, deps = []) => {
  const [uniqueId, setUniqueId] = useState(null)

  const { persistKey, allowOverride } = options || {}

  const persistedIds = localStorage && localStorage.getItem('realhub:unique-ids')
    ? JSON.parse(localStorage.getItem('realhub:unique-ids'))
    : {}

  const persistedId = persistedIds[persistKey]

  useEffect(() => {
    if (!uniqueId){
      const id = persistedId || generateUuid()
      setUniqueId(id)
      persistId(persistedIds, persistKey, id)
    }
  }, [persistedId])

  useEffect(() => {
    if (allowOverride){
      const id = persistedId || generateUuid()
      setUniqueId(id)
      persistId(persistedIds, persistKey, id)
    }
  }, [persistedId, ...deps])

  return [uniqueId, setUniqueId]
}

export default useUniqueId
